import http from 'api/httpClient';
import type { PnlLevel } from 'pages/pnl/api';

export type CNHoldLevel = PnlLevel;

export type UpdateCNHoldDropdownsRequest = {
    selection: Record<string, string[]>;
};

export type UpdateCNHoldDropdownsResponse = {
    levels: CNHoldLevel[];
};

export async function updateCNHoldDropdowns(payload: UpdateCNHoldDropdownsRequest): Promise<UpdateCNHoldDropdownsResponse> {
    return http.post('/api/v1/cn-hold/update-dropdowns', { ...payload });
}

export type CNHoldLookupRequest = {
    filters: Record<string, string[]>;
    cust_code?: string;
    stock_location?: string;
};

export type CNHoldLookupOption = {
    code: string;
    name: string;
};

export type CNHoldLookupResponse = {
    items: CNHoldLookupOption[];
};

export async function fetchCNHoldCustomers(payload: CNHoldLookupRequest): Promise<CNHoldLookupResponse> {
    return http.post('/api/v1/cn-hold/customers', payload);
}

export async function fetchCNHoldStockLocations(payload: CNHoldLookupRequest): Promise<CNHoldLookupResponse> {
    return http.post('/api/v1/cn-hold/stock-locations', payload);
}

export type CNHoldRow = {
    cn_number: string;
    cn_date: string | null;
    booking_branch: string | null;
    consignor: string | null;
    consignee: string | null;
    origin: string | null;
    destination: string | null;
    stock_location: string | null;
    stock_since: string | null;
    hold_by_user: string | null;
    hold_reason: string | null;
    remark: string | null;
};

export type FetchCNHoldDataRequest = {
    filters: Record<string, string[]>;
    search?: string;
    cust_code?: string;
    stock_location?: string;
    hold_reason?: string;
    page: number;
    per_page: number;
    sort_by: string;
    sort_order: 'asc' | 'desc';
};

export type FetchCNHoldDataResponse = {
    rows: CNHoldRow[];
    page: number;
    page_size: number;
    total_items: number;
    total_pages: number;
    has_previous: boolean;
    has_next: boolean;
};

export async function fetchCNHoldData(payload: FetchCNHoldDataRequest): Promise<FetchCNHoldDataResponse> {
    return http.post('/api/v1/cn-hold/fetch-data', payload);
}

export type DownloadCNHoldRequest = {
    filters: Record<string, string[]>;
    search?: string;
    cust_code?: string;
    stock_location?: string;
    hold_reason?: string;
    sort_by?: string;
    sort_order?: 'asc' | 'desc';
};

export async function downloadCNHold(payload: DownloadCNHoldRequest): Promise<Blob> {
    return http.post('/api/v1/cn-hold/download', payload, { responseType: 'blob' });
}